import axios from "axios"
import config from "../config"

const baseURL = config.api.url
const prefix = "/api/v1"

// GET PROFILE CONSENT
export const getConsent = (id, rrn) =>
  new Promise((resolve, reject) => {
    const url = `${baseURL + prefix}/tickets/${id}/consents`
    const headers = {
      "request-reference-no": rrn,
    }
    axios
      .get(url, { headers })
      .then((res) => {
        // console.log(res.data)
        resolve(res.data)
      })
      .catch((error) => {
        // console.log(error.message)
        reject(error)
      })
  })

// POST CONSENT
export const postConsent = (id, rrn, opt, fx) =>
  new Promise((resolve, reject) => {
    const cons = Array.isArray(opt) ? opt : []
    cons.forEach((e) => {
      const consent = e
      consent.optIn = true
    })
    const body = {
      consents: cons,
    }
    axios
      .post(`${baseURL + prefix}/tickets/${id}/consents`, body, {
        headers: { "request-reference-no": rrn },
      })
      .then((res) => {
        // console.log("successfully submitted consent form")
        // eslint-disable-next-line
        // console.log(res.data)
        resolve(res.data)
        fx() // setOptIn
      })
      .catch((error) => {
        // console.log(error.message)
        reject(error)
      })
  })
